import { BackendService } from './backend.service';
import { Module } from 'app/shared/models/Module';
import { Program } from 'app/shared/models/Program';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
var ExerciseService = (function () {
    function ExerciseService(backendService, translate) {
        this.backendService = backendService;
        this.translate = translate;
        /** Array containing all Exercise instances */
        this.allExercises = [];
        /** Array containing all Modules instances available for the user */
        this.allModules = [];
        /** Array containing all user d Programs */
        this.allMyPrograms = [];
        /** Array containing all main Categories */
        this.allMainCategories = [];
        /** s a random Exercise Program with programLength number of Exercises from the given category and module */
        this.randomExerciseIdHistory = [];
    }
    ExerciseService.prototype.getAllExercises = function () {
        var _this = this;
        // No need to load again if we already downloaded all of them
        if (this.allExercises !== undefined && this.allExercises.length != 0) {
            // already loaded from server, use cached data
            return Promise.resolve(this.allExercises);
        }
        else if (this.exercisePromise) {
            // not laoded, but the same request already went out
            return this.exercisePromise.then(function (exercises) {
                _this.allExercises = exercises;
                return _this.allExercises;
            });
        }
        // not loaded, not loading, initiate api call
        var tasks = [
            this.getMainCategories(),
            this.backendService.get("exercise/all/")
        ];
        this.exercisePromise = Promise.all(tasks).then(function (all) {
            var allCategories = all[0];
            var exercises = all[1];
            _this.allExercises = exercises.map(function (ex) {
                ex.previewUrl = environment.backendUrl + "exercise/image/" + ex._id + ".jpeg";
                ex.videoUrl = {
                    de: environment.backendUrl + "exercise/video/de/" + ex._id + ".mp4",
                    en: environment.backendUrl + "exercise/video/en/" + ex._id + ".mp4"
                };
                ex.captionUrl = {
                    de: environment.backendUrl + "exercise/caption/de/" + ex._id + ".vtt",
                    en: environment.backendUrl + "exercise/caption/en/" + ex._id + ".vtt"
                };
                ex.categories = [];
                ex.categoryIDs.forEach(function (item, index) {
                    var category = allCategories.find(function (cat) { return cat._id === item; });
                    if (category) {
                        ex.categories.push(category);
                    }
                });
                return ex;
            });
            _this.exercisePromise = undefined;
            return _this.allExercises;
        }).catch(function (error) {
            _this.exercisePromise = undefined;
            console.log(error);
            return [];
        });
        return this.exercisePromise;
    };
    ExerciseService.prototype.getModules = function () {
        var _this = this;
        // No need to load again if we already downloaded all of them
        if (this.allModules !== undefined && this.allModules.length != 0) {
            // already loaded from server, use cached data
            return Promise.resolve(this.allModules);
        }
        else if (this.modulePromise) {
            // not laoded, but the same request already went out
            return this.modulePromise.then(function (modules) {
                _this.allModules = modules;
                return _this.allModules;
            });
        }
        this.modulePromise = this.backendService.get("modules/").then(function (data) {
            _this.allModules = [];
            var exTasks = [];
            // get associated exercises by id
            for (var _i = 0, _a = data; _i < _a.length; _i++) {
                var m = _a[_i];
                var module_1 = Module.fromJson(m);
                _this.allModules.push(module_1);
                exTasks.push(_this.getExercises(module_1.exerciseIds));
            }
            return Promise.all(exTasks);
        }).then(function (all) {
            all.forEach(function (item, index) {
                _this.allModules[index].exercises = item;
            });
            _this.modulePromise = undefined;
            // set preview url
            _this.allModules.map(function (item) {
                item.previewUrl = environment.backendUrl + "module/image/" + item._id + ".jpeg";
            });
            return _this.allModules;
        }).catch(function (error) {
            console.log(error);
            return [];
        });
        return this.modulePromise;
    };
    ExerciseService.prototype.getExercise = function (id) {
        return this.getAllExercises().then(function (exs) {
            return exs.filter(function (ex) { return ex._id == id; })[0];
        });
    };
    ExerciseService.prototype.getExercises = function (ids) {
        var tasks = [];
        for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
            var id = ids_1[_i];
            tasks.push(this.getExercise(id));
        }
        return Promise.all(tasks);
    };
    ExerciseService.prototype.createRandomProgram = function (module, category) {
        var _this = this;
        var randomProgram = new Program();
        randomProgram.isRandom = true;
        randomProgram.title = module.title[this.translate.currentLang];
        randomProgram.exerciseIds = [];
        randomProgram.exercises = [];
        randomProgram.contextID = module._id;
        var possibleExercises = [];
        var pSize = 0;
        if (category) {
            // when a category is specified we filter out every exercise that hat this category
            possibleExercises = module.exercises.filter(function (ex) {
                // exercise has category
                return ex.categoryIDs.find(function (cat) { return cat == category._id; }) != undefined;
            });
            pSize = Math.min((module.randomProgramSize || 1), possibleExercises.length);
        }
        else {
            // no category specified so we just take all
            possibleExercises = module.exercises;
            pSize = Math.min((module.randomProgramSize || 1), module.exercises.length);
        }
        // filter exercises that have already been viewed
        possibleExercises = possibleExercises.filter(function (ex) { return _this.randomExerciseIdHistory.find(function (id) { return id == ex._id; }) == undefined; });
        // in case we can't find an exercise like this, reset history and try again
        if (possibleExercises.length < pSize) {
            this.randomExerciseIdHistory = [];
            console.log("reset view history");
            return this.createRandomProgram(module, category);
        }
        //  as many random programs as necessary and possible
        for (var i = 0; i < pSize && i < possibleExercises.length; i++) {
            // find random exercise
            var index = Math.ceil(Math.random() * possibleExercises.length) - 1;
            var ex = possibleExercises[index];
            // remove from list so we dont get doubles
            possibleExercises.splice(index, 1);
            // add to program
            randomProgram.exercises.push(ex);
            this.randomExerciseIdHistory.push(ex._id);
        }
        for (var _i = 0, _a = randomProgram.exercises; _i < _a.length; _i++) {
            var ex_1 = _a[_i];
            randomProgram.exerciseIds.push(ex_1._id);
        }
        console.log(randomProgram.exerciseIds);
        // resolve exercise IDs
        return Promise.resolve(randomProgram);
    };
    ExerciseService.prototype.getMyPrograms = function () {
        var _this = this;
        // No need to load again if we already downloaded all of them
        if (this.allMyPrograms !== undefined && this.allMyPrograms.length != 0) {
            // already loaded from server, use cached data
            return Promise.resolve(this.allMyPrograms);
        }
        // load from "server"
        /* Loads my programs and associated exercises from server */
        return this.backendService.get("programs").then(function (data) {
            _this.allMyPrograms = [];
            var tasks = [];
            // get associated exercises by id
            for (var _i = 0, _a = data; _i < _a.length; _i++) {
                var p = _a[_i];
                var program = Program.fromJson(p);
                _this.allMyPrograms.push(program);
                tasks.push(_this.getExercises(program.exerciseIds));
            }
            return Promise.all(tasks).then(function (all) {
                all.forEach(function (item, index) {
                    _this.allMyPrograms[index].exercises = item;
                    _this.allMyPrograms[index].previewUrl = "";
                    if (_this.allMyPrograms[index].exercises.length != 0) {
                        _this.allMyPrograms[index].previewUrl = _this.allMyPrograms[index].exercises[0].previewUrl;
                    }
                });
                return _this.allMyPrograms;
            });
        });
    };
    ExerciseService.prototype.saveNewProgram = function (program) {
        var _this = this;
        return this.backendService.post("programs", program).then(function (result) {
            program._id = result._id;
            _this.allMyPrograms.splice(0, 0, program);
            return result;
        });
    };
    ExerciseService.prototype.updateMyProgram = function (program) {
        var _this = this;
        return this.backendService.put("programs/" + program._id + "/", program).then(function (result) {
            for (var _i = 0, _a = _this.allMyPrograms; _i < _a.length; _i++) {
                var p = _a[_i];
                if (p._id == program._id) {
                    p = program;
                }
            }
            return result;
        });
    };
    ExerciseService.prototype.deleteMyProgram = function (program) {
        var _this = this;
        return this.backendService.delete_("programs/" + program._id + "/").then(function (result) {
            _this.allMyPrograms.splice(_this.allMyPrograms.indexOf(program), 1);
            return result;
        });
    };
    ExerciseService.prototype.getMainCategories = function () {
        var _this = this;
        // No need to load again if we already downloaded all of them
        if (this.allMainCategories !== undefined && this.allMainCategories.length != 0) {
            // already loaded from server, use cached data
            return Promise.resolve(this.allMainCategories);
        }
        else if (this.mainCategoryPromise) {
            // not laoded, but the same request already went out
            return this.mainCategoryPromise.then(function (categories) {
                _this.allMainCategories = categories;
                return _this.allMainCategories;
            });
        }
        // load from server
        this.mainCategoryPromise = this.backendService.get("category/main").then(function (categories) {
            _this.allMainCategories = categories;
            _this.mainCategoryPromise = undefined;
            return _this.allMainCategories;
        }).catch(function (error) {
            _this.mainCategoryPromise = undefined;
            console.log(error);
            return [];
        });
        return this.mainCategoryPromise;
    };
    /**
     * Called when user finishes a module to trigger team challenge bonus point calculation in backend
     */
    ExerciseService.prototype.moduleFinished = function (moduleID) {
        return this.backendService.post("modules/" + moduleID + "/watched").then().catch();
    };
    return ExerciseService;
}());
export { ExerciseService };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/exercises.service.ts.pre-build-optimizer.js